// Generated by ReScript, PLEASE EDIT WITH CARE


function getVm(customer) {
  return {
          id: customer.id,
          name: customer.name,
          vendor_name: customer.vendor_name,
          primary_number: customer.primary_number,
          secondary_number: customer.secondary_number
        };
}

var CustomerVm = {
  getVm: getVm
};

function getVm$1(partner) {
  return {
          msisdn: partner.msisdn,
          name: partner.name,
          primary_number: partner.primary_number,
          secondary_number: partner.secondary_number,
          owner_number: partner.owner_number
        };
}

var PartnerVm = {
  getVm: getVm$1
};

export {
  CustomerVm ,
  PartnerVm ,
  
}
/* No side effect */
